import http from "../../http-common";
/* eslint-disable */
class BeritaFotoService {
  beritaFotoList(page, itemPerPage, beritaId) {
    return http.get(
      "/berita-foto/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&berita_id=" +
        beritaId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("berita_id", data.berita_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/berita-foto", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("berita_id", data.berita_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/berita-foto/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/berita-foto/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new BeritaFotoService();
